import React from "react";
import { ImageContainter, TagContainer } from "./style";
import { getCloudinaryUrl } from "@swiggy-private/core-ui";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { CalloutInfo, StylesObject } from "@dineout-payment-success-ui/interfaces";
import { isEmpty } from "@swiggy-private/js-utils";

export interface ITagProps {
    info: CalloutInfo;
    isSavingsAvailable: boolean;
    styles?: StylesObject;
    isSavingCardsAvailable: boolean;
}
const CalloutTag: React.FC<ITagProps> = ({ info, isSavingsAvailable, styles, isSavingCardsAvailable }: ITagProps) => {
    if (isEmpty(info)) {
        return null;
    }
    const bgImage = !isSavingsAvailable ? styles?.backgroundGradientImage : "";
    return (
        <TagContainer
            backgroundColor={info?.backgroundColor}
            borderColor={info?.borderColor}
            isSavingsAvailable={isSavingsAvailable}
            bgImage={bgImage}
            isSavingCardsAvailable={isSavingCardsAvailable}
        >
            <ImageContainter>
                <Image src={getCloudinaryUrl(info?.imageUrl)} />
            </ImageContainter>
        </TagContainer>
    );
};

export default React.memo(CalloutTag);
